// Immediately hide login popup on page load (inline execution)
// @ts-nocheck
(function () {
  const loginPopup = document.getElementById("login-popup");
  const loginDialog = document.querySelector(".login-popup__dialog");

  if (loginPopup) {
    loginPopup.style.cssText = "display: none !important; visibility: hidden !important; opacity: 0 !important;";
    loginPopup.classList.remove("is-open");
  }

  if (loginDialog) {
    loginDialog.removeAttribute("open");
    loginDialog.style.cssText = "display: none !important; visibility: hidden !important; opacity: 0 !important; pointer-events: none !important;";
    if (loginDialog.open) {
      try {
        loginDialog.close();
      } catch (e) { }
    }
  }

  // Auto-open login popup if URL parameter is present
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get("open_login") === "true") {
    // Wait for dialog component to be ready
    setTimeout(function () {
      const loginButton = document.querySelector('[data-dialog-trigger="#login-popup"]');
      if (loginButton) {
        loginButton.click();
        // Clean up URL
        const newUrl = window.location.pathname;
        window.history.replaceState({}, "", newUrl);
      } else {
        // Try finding the login-popup component directly
        const loginPopup = document.getElementById("login-popup");
        if (loginPopup && loginPopup.openDialog) {
          loginPopup.openDialog();
          // Clean up URL
          const newUrl = window.location.pathname;
          window.history.replaceState({}, "", newUrl);
        }
      }
    }, 500);
  }
})();

// Reopen the cart automatically after a login that was triggered by the cart
// button (customer clicked "My Bag" while logged out). The flag is set in
// sessionStorage by the cart button so it survives the full-page redirect
// that a successful login can trigger.
function pwstTryOpenCartAfterLogin(attempt) {
  attempt = attempt || 0;
  // The cart script now loads after the LCP; pwOpenSideCart waits for it.
  if (typeof window.pwOpenSideCart === "function") {
    try {
      window.pwOpenSideCart();
      return;
    } catch (e) {
      console.error("Error opening cart after login:", e);
    }
  }
  if (typeof window.openGokwikSideCart === "function") {
    try {
      window.openGokwikSideCart();
      return;
    } catch (e) {
      console.error("Error opening cart after login:", e);
    }
  }
  if (attempt < 4) {
    setTimeout(function () {
      pwstTryOpenCartAfterLogin(attempt + 1);
    }, 500);
  }
}

function pwstMaybeOpenCartAfterLogin() {
  try {
    if (sessionStorage.getItem("pwstOpenCartAfterLogin") === "1") {
      sessionStorage.removeItem("pwstOpenCartAfterLogin");
      pwstTryOpenCartAfterLogin(0);
    }
  } catch (e) {}
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", pwstMaybeOpenCartAfterLogin);
} else {
  pwstMaybeOpenCartAfterLogin();
}

// Function to fetch policy content
async function fetchPolicyContent(url) {
  try {
    const response = await fetch(url);
    const html = await response.text();

    // Create a temporary DOM element to parse the HTML
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    // Try to find the main content area
    // Common selectors for Shopify policy pages
    let content = doc.querySelector(".shopify-policy__container");
    if (!content) content = doc.querySelector(".rte");
    if (!content) content = doc.querySelector("main");
    if (!content) content = doc.querySelector(".main-content");
    if (!content) content = doc.querySelector("article");

    if (content) {
      return content.innerHTML;
    } else {
      // Fallback: get body content
      return doc.body.innerHTML;
    }
  } catch (error) {
    console.error("Error fetching policy content:", error);
    return '<p>Unable to load content. Please visit the <a href="' + url + '" target="_blank">policy page</a> directly.</p>';
  }
}

// Function to show content in the same popup
window.showContentInPopup = async function (type) {
  const loginFormContent = document.getElementById("login-form-content");
  const nameInputContent = document.getElementById("name-input-content");
  const otpVerificationContent = document.getElementById("otp-verification-content");
  const contentView = document.getElementById("content-view");
  const contentTitle = document.getElementById("content-view-title");
  const contentBody = document.getElementById("content-view-body");
  const closeButton = document.getElementById("popup-close-button");

  // Track which view is currently active
  if (loginFormContent && loginFormContent.style.display !== "none") {
    previousView = "login";
  } else if (nameInputContent && nameInputContent.style.display !== "none") {
    previousView = "name";
  } else if (otpVerificationContent && otpVerificationContent.style.display !== "none") {
    previousView = "otp";
  }

  let url = "";
  let title = "";

  if (type === "privacy") {
    url = "/policies/privacy-policy";
    title = "Privacy Policy";
  } else if (type === "terms") {
    url = "/policies/terms-of-service";
    title = "Terms of Service";
  }

  // Show loading state
  contentTitle.textContent = title;
  contentBody.innerHTML = '<div class="country-selector-loading">Loading...</div>';

  // Hide all other views, show content view
  loginFormContent.style.display = "none";
  if (nameInputContent) nameInputContent.style.display = "none";
  if (otpVerificationContent) otpVerificationContent.style.display = "none";
  contentView.style.display = "flex";
  if (closeButton) {
    closeButton.style.display = "none";
  }

  // Fetch and display content
  const content = await fetchPolicyContent(url);
  contentBody.innerHTML = '<div class="content-body">' + content + "</div>";
};

// Function to show login form again
window.showLoginForm = function () {
  const loginFormContent = document.getElementById("login-form-content");
  const contentView = document.getElementById("content-view");
  const nameInputContent = document.getElementById("name-input-content");
  const otpVerificationContent = document.getElementById("otp-verification-content");
  const closeButton = document.getElementById("popup-close-button");

  // Hide content view
  contentView.style.display = "none";

  // Show the previous view based on what was active
  if (previousView === "name" && nameInputContent) {
    loginFormContent.style.display = "none";
    nameInputContent.style.display = "block";
    if (otpVerificationContent) otpVerificationContent.style.display = "none";
  } else if (previousView === "otp" && otpVerificationContent) {
    loginFormContent.style.display = "none";
    if (nameInputContent) nameInputContent.style.display = "none";
    otpVerificationContent.style.display = "block";
  } else {
    // Default to login form
    loginFormContent.style.display = "block";
    if (nameInputContent) nameInputContent.style.display = "none";
    if (otpVerificationContent) otpVerificationContent.style.display = "none";
  }

  if (closeButton) {
    closeButton.style.display = "flex";
  }
};

// Helper function to get error message
function getErrorMessage(errors, fallbackMessage) {
  const errorMessage = errors?.map((error) => error.message).join("\n");
  return errorMessage || fallbackMessage;
}

// OTP Functionality
let userPhoneNumber = "";
let userCountryCode = "";
let resendTimer = null;
let resendCountdown = 30; // 30 seconds
let previousView = "login"; // Track which view was active before showing Terms/Privacy

// Cloudflare Turnstile – validate first, then enable Get OTP / Resend OTP / Register
const captchaToken = { send: null, resend: null, register: null };

function getCaptchaContainer(type) {
  if (type === "send") return document.getElementById("login-turnstile-widget");
  if (type === "resend") return document.getElementById("resend-turnstile-widget");
  if (type === "register") return document.getElementById("register-turnstile-widget");
  return null;
}

function hideCaptcha(type) {
  const container = getCaptchaContainer(type);
  captchaToken[type] = null;

  if (!container) return;
  if (container._widgetId != null && window.turnstile) {
    try {
      window.turnstile.remove(container._widgetId);
    } catch (e) {}
  }
  container._widgetId = null;
  container.classList.remove("is-visible");
  container.innerHTML = "";
}

function waitForTurnstile() {
  return new Promise(function (resolve) {
    if (window.turnstile) return resolve(true);
    const start = Date.now();
    const timer = setInterval(function () {
      if (window.turnstile || Date.now() - start > 10000) {
        clearInterval(timer);
        resolve(Boolean(window.turnstile));
      }
    }, 100);
  });
}

function showCaptchaError(type, message) {
  if (type === "send" && typeof window.showGetOTPError === "function") {
    window.showGetOTPError(message);
  } else if (type === "resend" && typeof window.showOTPVerifyError === "function") {
    window.showOTPVerifyError(message);
  } else if (type === "register" && typeof window.showNameInputError === "function") {
    window.showNameInputError(message);
  }
}

// Show captcha widget. onPass() runs after user completes or token expires.
async function showCaptcha(type, onPass) {
  const container = getCaptchaContainer(type);
  if (!container) return;

  hideCaptcha(type);

  const ready = await waitForTurnstile();
  if (!ready) {
    showCaptchaError(type, "Captcha could not load. Please refresh the page.");
    return;
  }

  const primaryKey = window.PW_CLOUDFLARE_CAPTCHA_SITE_KEY || "";
  const fallbackKey = window.PW_CLOUDFLARE_CAPTCHA_SITE_KEY_FALLBACK || "";
  if (!primaryKey) {
    showCaptchaError(type, "Captcha is not configured.");
    return;
  }

  function render(siteKey, useFallback) {
    if (container._widgetId != null && window.turnstile) {
      try {
        window.turnstile.remove(container._widgetId);
      } catch (e) {}
    }
    container.innerHTML = "";
    container.classList.add("is-visible");

    container._widgetId = window.turnstile.render(container, {
      sitekey: siteKey,
      theme: "light",
      callback: function (token) {
        captchaToken[type] = {
          captchaSiteKey: siteKey,
          captchaToken: token,
          useFallback: useFallback,
        };
        if (typeof onPass === "function") onPass();
      },
      "expired-callback": function () {
        captchaToken[type] = null;
        if (typeof onPass === "function") onPass();
        if (container._widgetId != null && window.turnstile) {
          try {
            window.turnstile.reset(container._widgetId);
          } catch (e) {}
        }
      },
      "error-callback": function () {
        if (!useFallback && fallbackKey && fallbackKey !== siteKey) {
          render(fallbackKey, true);
          return;
        }
        captchaToken[type] = null;
        if (typeof onPass === "function") onPass();
        showCaptchaError(type, "Captcha failed to load. Please refresh the page.");
      },
    });
  }

  render(primaryKey, false);
}

function otpApiUrl(path, useFallback) {
  const base = `${window.PW_API_BASE || "/apps/pw_module/api"}${path}`;
  return useFallback ? `${base}?fallback=true` : base;
}

function showResendButton() {
  const otpResendDisplay = document.getElementById("otpResendDisplay");
  if (otpResendDisplay) otpResendDisplay.style.display = "inline";
}

function hideResendButton() {
  const otpResendDisplay = document.getElementById("otpResendDisplay");
  if (otpResendDisplay) otpResendDisplay.style.display = "none";
}

function showOTPView(phone, countryCode) {
  const loginFormContent = document.getElementById("login-form-content");
  const otpVerificationContent = document.getElementById("otp-verification-content");
  const nameInputContent = document.getElementById("name-input-content");
  const otpPhoneNumber = document.getElementById("otp-phone-number");

  userPhoneNumber = phone;
  userCountryCode = countryCode;

  // Display phone number in OTP view
  if (otpPhoneNumber) {
    otpPhoneNumber.textContent = countryCode + phone;
  }

  // Hide other views, show OTP verification
  loginFormContent.style.display = "none";
  if (nameInputContent) nameInputContent.style.display = "none";
  otpVerificationContent.style.display = "block";

  // Focus first OTP input to open numeric keypad on mobile
  setTimeout(() => {
    const firstInput = document.getElementById("otp-1");
    if (firstInput) firstInput.focus();
  }, 300);

  // Clear any previous OTP values
  clearOTPInputs();
  hideOTPError();

  // Start resend timer
  startResendTimer();
}

// Show Name Input view (for new users)
function showNameInputView(phone, countryCode) {
  const loginFormContent = document.getElementById("login-form-content");
  const nameInputContent = document.getElementById("name-input-content");
  const otpVerificationContent = document.getElementById("otp-verification-content");
  const userNameInput = document.getElementById("userNameInput");
  const continueButton = document.getElementById("continueWithNameButton");

  userPhoneNumber = phone;
  userCountryCode = countryCode;

  // Reset continue button state
  if (continueButton) {
    continueButton.classList.remove("active");
  }

  // Clear name input
  if (userNameInput) {
    userNameInput.value = "";
  }

  if (typeof window.resetLoginNameEntryTracking === "function") {
    window.resetLoginNameEntryTracking();
  }
  if (typeof window.attachLoginNameEntryTracking === "function") {
    window.attachLoginNameEntryTracking();
  }

  // Hide other views, show name input
  loginFormContent.style.display = "none";
  otpVerificationContent.style.display = "none";
  if (nameInputContent) {
    nameInputContent.style.display = "block";

    // Focus name input
    setTimeout(() => {
      if (userNameInput) userNameInput.focus();
    }, 100);
  }

  // Same Turnstile flow as Get OTP — show captcha on signup/register view
  hideCaptcha("send");
  hideCaptcha("resend");
  showCaptcha("register", function () {
    if (typeof window.updateContinueButtonState === "function") {
      window.updateContinueButtonState();
    }
  });
  if (typeof window.updateContinueButtonState === "function") {
    window.updateContinueButtonState();
  }
}

// Format time as mm:ss
function formatTime(seconds) {
  const minutes = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
}

// Start resend OTP timer
function startResendTimer() {
  const otpTimer = document.getElementById("otpTimer");
  const otpTimerDisplay = document.getElementById("otpTimerDisplay");

  if (!otpTimer || !otpTimerDisplay) return;

  resendCountdown = 60;
  hideCaptcha("resend");
  hideResendButton();
  otpTimerDisplay.style.display = "inline";
  otpTimer.textContent = formatTime(resendCountdown);

  if (resendTimer) clearInterval(resendTimer);

  resendTimer = setInterval(() => {
    resendCountdown--;

    if (resendCountdown > 0) {
      otpTimer.textContent = formatTime(resendCountdown);
      return;
    }

    clearInterval(resendTimer);
    resendTimer = null;
    otpTimerDisplay.style.display = "none";

    // Timer done → show captcha first; Resend OTP appears only after captcha passes
    showCaptcha("resend", function () {
      if (captchaToken.resend) {
        showResendButton();
      } else {
        hideResendButton();
      }
    });
  }, 1000);
}

// Edit phone number - go back to login form
window.editPhoneNumber = function () {
  const loginFormContent = document.getElementById("login-form-content");
  const otpVerificationContent = document.getElementById("otp-verification-content");
  const nameInputContent = document.getElementById("name-input-content");
  const contentView = document.getElementById("content-view");
  const closeButton = document.getElementById("popup-close-button");
  const otpTimerDisplay = document.getElementById("otpTimerDisplay");

  loginFormContent.style.display = "block";
  otpVerificationContent.style.display = "none";
  if (nameInputContent) nameInputContent.style.display = "none";
  sessionStorage.removeItem('isNewUser');
  sessionStorage.removeItem('pwstOtpVerified');
  sessionStorage.removeItem('pwstOtpVerifiedAt');

  // Also hide content view if it was open
  if (contentView) {
    contentView.style.display = "none";
  }

  // Ensure close button is visible
  if (closeButton) {
    closeButton.style.display = "flex";
  }

  // Clear timer
  if (resendTimer) {
    clearInterval(resendTimer);
    resendTimer = null;
  }

  // Reset timer display
  if (otpTimerDisplay) {
    otpTimerDisplay.style.display = "none";
  }
  hideResendButton();

  // Clear OTP inputs
  clearOTPInputs();
  hideOTPError();
  hideCaptcha("resend");
  hideCaptcha("register");

  // Always show send captcha when returning to login form
  showCaptcha("send", window.updateGetOTPButtonState);
  if (typeof window.updateGetOTPButtonState === "function") {
    window.updateGetOTPButtonState();
  }
};

// Resend OTP
window.resendOTP = async function () {
  console.log("Resending OTP to:", userCountryCode + userPhoneNumber);

  const resendButton = document.getElementById("resendOTPButton");
  if (!resendButton || resendButton.disabled) return;

  const captcha = captchaToken.resend;
  if (!captcha) {
    showOTPVerifyError("Please complete the captcha verification");
    return;
  }

  resendButton.disabled = true;
  const originalText = resendButton.textContent;
  resendButton.textContent = "Sending...";

  try {
    hideOTPVerifyError();
    const response = await fetch(otpApiUrl("/users/resend-otp", captcha.useFallback), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        phone: userPhoneNumber,
        countryCode: userCountryCode,
        captchaSiteKey: captcha.captchaSiteKey,
        captchaToken: captcha.captchaToken,
        isCaptchaEnabled: true,
      }),
    });

    const data = await response.json();
    console.log("Resend OTP response:", data);

    if (response.ok && data.status === "success") {
      console.log("OTP resent successfully");
      clearOTPInputs();
      hideOTPError();
      hideOTPVerifyError();
      hideCaptcha("resend");
      startResendTimer();
    } else {
      const errorMessage = data.message || "Failed to resend OTP. Please try again.";
      showOTPVerifyError(errorMessage);
      console.error("OTP resend failed:", data);
      // Captcha tokens are one-time — refresh captcha and hide resend until passed again
      hideResendButton();
      showCaptcha("resend", function () {
        if (captchaToken.resend) showResendButton();
        else hideResendButton();
      });
    }
  } catch (error) {
    console.error("Error resending OTP:", error);
    showOTPVerifyError("An error occurred while resending OTP. Please try again.");
    hideResendButton();
    showCaptcha("resend", function () {
      if (captchaToken.resend) showResendButton();
      else hideResendButton();
    });
  } finally {
    resendButton.disabled = false;
    resendButton.textContent = originalText;
  }
};

// Clear all OTP inputs
function clearOTPInputs() {
  for (let i = 1; i <= 6; i++) {
    const input = document.getElementById("otp-" + i);
    if (input) {
      input.value = "";
      input.classList.remove("error");
    }
  }
  // Reset verify button state
  const verifyButton = document.getElementById("verifyOTPButton");
  if (verifyButton) {
    verifyButton.classList.remove("active");
  }
}

// Show OTP error
function showOTPError() {
  const otpError = document.getElementById("otpError");
  if (otpError) {
    otpError.style.display = "flex";
  }

  // Add error class to inputs
  for (let i = 1; i <= 6; i++) {
    const input = document.getElementById("otp-" + i);
    if (input) {
      input.classList.add("error");
    }
  }
}

// Hide OTP error
function hideOTPError() {
  const otpError = document.getElementById("otpError");
  if (otpError) {
    otpError.style.display = "none";
  }

  // Remove error class from inputs
  for (let i = 1; i <= 6; i++) {
    const input = document.getElementById("otp-" + i);
    if (input) {
      input.classList.remove("error");
    }
  }
}

// Global variables for country selector
let countriesData = [];
let selectedCountry = { code: "+91", iso: "IN", name: "India" };

// Get selected country code (for OTP functionality)
window.getSelectedCountryCode = function () {
  return selectedCountry.code;
};

function fireTrackGetOTPClick(payload) {
  const track =
    typeof window.trackGetOTPClick === "function"
      ? window.trackGetOTPClick
      : typeof trackGetOTPClick === "function"
        ? trackGetOTPClick
        : null;
  if (!track) return;

  const schedule =
    typeof requestIdleCallback === "function"
      ? requestIdleCallback
      : function (cb) {
          setTimeout(cb, 0);
        };
  schedule(function () {
    track(payload);
  });
}

// Error message handling for Get OTP button
let getOTPErrorTimeout = null;

window.showGetOTPError = function (message) {
  const errorElement = document.getElementById("otpErrorMessage");
  const errorText = errorElement ? errorElement.querySelector(".otp-error-text") : null;

  if (errorElement && errorText) {
    errorText.textContent = message;
    errorElement.style.display = "flex";

    // Clear any existing timeout
    if (getOTPErrorTimeout) {
      clearTimeout(getOTPErrorTimeout);
    }

    // Auto-hide after 1 minute (60000 milliseconds)
    getOTPErrorTimeout = setTimeout(function () {
      hideGetOTPError();
    }, 60000);
  }
};

window.hideGetOTPError = function () {
  const errorDiv = document.getElementById("otpErrorMessage");
  if (errorDiv) {
    errorDiv.style.display = "none";

    // Clear the timeout if manually closed
    if (getOTPErrorTimeout) {
      clearTimeout(getOTPErrorTimeout);
      getOTPErrorTimeout = null;
    }
  }
};

// Error message handling for OTP Verification
let otpVerifyErrorTimeout = null;

window.showOTPVerifyError = function (message) {
  const otpError = document.getElementById("otpError");
  const errorText = otpError ? otpError.querySelector(".otp-error-text") : null;

  if (otpError && errorText) {
    errorText.textContent = message || "Invalid OTP";
    otpError.style.display = "flex";

    // Clear any existing timeout
    if (otpVerifyErrorTimeout) {
      clearTimeout(otpVerifyErrorTimeout);
    }

    // Auto-hide after 1 minute (60000 milliseconds)
    otpVerifyErrorTimeout = setTimeout(function () {
      hideOTPVerifyError();
    }, 60000);
  }
};

window.hideOTPVerifyError = function () {
  const otpError = document.getElementById("otpError");

  if (otpError) {
    otpError.style.display = "none";

    // Clear the timeout if manually closed
    if (otpVerifyErrorTimeout) {
      clearTimeout(otpVerifyErrorTimeout);
      otpVerifyErrorTimeout = null;
    }
  }
};

// Error message handling for Name Input
let nameInputErrorTimeout = null;

window.showNameInputError = function (message) {
  const errorDiv = document.getElementById("nameInputErrorMessage");
  const errorText = errorDiv.querySelector(".otp-error-text");

  if (errorDiv && errorText) {
    errorText.textContent = message;
    errorDiv.style.display = "flex";

    // Clear any existing timeout
    if (nameInputErrorTimeout) {
      clearTimeout(nameInputErrorTimeout);
    }

    // Auto-hide after 1 minute (60000 milliseconds)
    nameInputErrorTimeout = setTimeout(function () {
      hideNameInputError();
    }, 60000);
  }
};

window.hideNameInputError = function () {
  const errorDiv = document.getElementById("nameInputErrorMessage");
  if (errorDiv) {
    errorDiv.style.display = "none";

    // Clear the timeout if manually closed
    if (nameInputErrorTimeout) {
      clearTimeout(nameInputErrorTimeout);
      nameInputErrorTimeout = null;
    }
  }
};

// Clean close button function
function cleanLoginPopupCloseButton() {
  const closeButtons = document.querySelectorAll(".login-popup__close, #popup-close-button");
  closeButtons.forEach((button) => {
    if (!button) return;
    // Remove any text nodes
    Array.from(button.childNodes).forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
        node.textContent = "";
      } else if (node.nodeType === Node.ELEMENT_NODE && !node.classList.contains("svg-wrapper")) {
        node.remove();
      }
    });
  });
}

// OTP Input Handling
document.addEventListener("DOMContentLoaded", function () {
  // Ensure dialog is completely closed and hidden on page load
  const loginPopupComponent = document.getElementById("login-popup");
  const loginPopupDialog = document.querySelector(".login-popup__dialog");

  if (loginPopupDialog) {
    // Close dialog if open
    if (loginPopupDialog.open) {
      try {
        loginPopupDialog.close();
      } catch (e) {
        console.log("Dialog close error:", e);
      }
    }
    loginPopupDialog.removeAttribute("open");
    loginPopupDialog.style.display = "none";
    loginPopupDialog.style.visibility = "hidden";
    loginPopupDialog.style.opacity = "0";
    loginPopupDialog.style.pointerEvents = "none";
  }

  // Hide the dialog component
  if (loginPopupComponent) {
    loginPopupComponent.classList.remove("is-open");
    loginPopupComponent.style.display = "none";
    loginPopupComponent.style.visibility = "hidden";
    loginPopupComponent.style.opacity = "0";
  }

  // Clean close button
  cleanLoginPopupCloseButton();
  setTimeout(cleanLoginPopupCloseButton, 100);
  setTimeout(cleanLoginPopupCloseButton, 500);

  // Hide error message when user starts typing in phone input
  const phoneInput = document.getElementById("smlPhoneNumberInput");
  if (phoneInput) {
    phoneInput.addEventListener("input", function () {
      const cleaned = this.value.replace(/\D/g, "");
      if (this.value !== cleaned) {
        this.value = cleaned;
      }

      hideGetOTPError();
      updateGetOTPButtonState();
    });
  }

  // Enable Get OTP only when phone is valid AND captcha has passed
  function updateGetOTPButtonState() {
    const phoneInput = document.getElementById("smlPhoneNumberInput");
    const getOTPButton = document.getElementById("getOTPButton");
    if (!phoneInput || !getOTPButton) return;

    const phoneLength = phoneInput.value.replace(/\D/g, "").length;
    if (phoneLength === 10 && captchaToken.send) {
      getOTPButton.classList.add("active");
    } else {
      getOTPButton.classList.remove("active");
    }
  }
  window.updateGetOTPButtonState = updateGetOTPButtonState;

  // Function to handle Get OTP (reusable for both button click and Enter key)
  async function handleGetOTP() {
    const phoneInput = document.getElementById("smlPhoneNumberInput");
    const getOTPButton = document.getElementById("getOTPButton");

    hideGetOTPError();

    if (!phoneInput) {
      showGetOTPError("Please enter your mobile number");
      return;
    }

    const rawPhone = phoneInput.value.trim();
    if (!rawPhone) {
      showGetOTPError("Please enter your mobile number");
      return;
    }

    if (!/^[0-9]+$/.test(rawPhone)) {
      showGetOTPError("Mobile number must contain only digits (0-9).");
      return;
    }

    if (rawPhone.length < 7) {
      showGetOTPError("Please enter a valid 10-digit mobile number");
      return;
    }

    if (
      !window.__PW_LOGIN_FIRST_DIGIT_TRACKED__ &&
      phoneInput.value.replace(/\D/g, "").length > 0 &&
      typeof window.tryTrackMobileNumberClick === "function"
    ) {
      window.tryTrackMobileNumberClick();
    }

    const captcha = captchaToken.send;
    if (!captcha) {
      showGetOTPError("Please complete the captcha verification");
      return;
    }

    const phone = rawPhone;
    const countryCode = selectedCountry.code;

    if (!getOTPButton) return;

    getOTPButton.disabled = true;
    const originalText = getOTPButton.textContent;
    getOTPButton.textContent = "Sending OTP...";

    try {
      const response = await fetch(otpApiUrl("/users/send-otp", captcha.useFallback), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          phone: phone,
          countryCode: countryCode,
          captchaSiteKey: captcha.captchaSiteKey,
          captchaToken: captcha.captchaToken,
          isCaptchaEnabled: true,
        }),
      });

      const data = await response.json();
      const errorMessage = getErrorMessage(data?.errors, "Failed to send OTP. Please try again.");

      if (response.ok && data.status === "success") {
        console.log("OTP sent successfully:", data);
        fireTrackGetOTPClick({ status: "success", entered_mobile_number: phone });
        hideGetOTPError();
        hideCaptcha("send");
        showOTPView(phone, countryCode);
      } else if (data.statusCode === 400 && errorMessage === "User does not exist") {
        console.log("User not found - showing name input screen");
        hideGetOTPError();
        hideCaptcha("send");
        showNameInputView(phone, countryCode);
      } else {
        console.log("errorMessage", errorMessage);
        fireTrackGetOTPClick({ status: "failed", entered_mobile_number: phone });
        showGetOTPError(errorMessage);
        console.error("OTP request failed:", data);
        // Refresh captcha after failed attempt (token is one-time)
        showCaptcha("send", updateGetOTPButtonState);
        updateGetOTPButtonState();
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
      fireTrackGetOTPClick({ status: "failed", entered_mobile_number: phone });
      showGetOTPError("An error occurred while sending OTP. Please try again.");
      showCaptcha("send", updateGetOTPButtonState);
      updateGetOTPButtonState();
    } finally {
      getOTPButton.disabled = false;
      getOTPButton.textContent = originalText;
    }
  }

  // Get OTP Button Handler
  const getOTPButton = document.getElementById("getOTPButton");
  if (getOTPButton) {
    getOTPButton.addEventListener("click", async function (e) {
      e.preventDefault();
      await handleGetOTP();
    });
  }

  // Add Enter key support for phone input
  if (phoneInput) {
    phoneInput.addEventListener("keydown", async function (e) {
      if (e.key === "Enter") {
        e.preventDefault();
        await handleGetOTP();
      }
    });
  }

  // Hide error message when user starts typing in name input
  const userNameInput = document.getElementById("userNameInput");
  if (userNameInput) {
    userNameInput.addEventListener("input", function (e) {
      // Remove numbers and special characters (keep only letters, spaces, and common name characters like hyphens and apostrophes)
      const value = e.target.value.replace(/[0-9]/g, '');
      if (value !== e.target.value) {
        e.target.value = value;
      }
      hideNameInputError();
      // Update Continue button state based on name length
      updateContinueButtonState();
    });

    // Handle Enter key press to trigger Continue button
    userNameInput.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.keyCode === 13) {
        e.preventDefault();
        const continueButton = document.getElementById("continueWithNameButton");
        if (continueButton) {
          continueButton.click();
        }
      }
    });
  }

  // Prevent form submission on Enter key
  const nameInputForm = document.getElementById("nameInputForm");
  if (nameInputForm) {
    nameInputForm.addEventListener("submit", function (e) {
      e.preventDefault();
      const continueButton = document.getElementById("continueWithNameButton");
      if (continueButton) {
        continueButton.click();
      }
    });
  }

  // Function to update Continue button state (name + captcha for signup/register)
  function updateContinueButtonState() {
    const userNameInput = document.getElementById("userNameInput");
    const continueButton = document.getElementById("continueWithNameButton");

    if (userNameInput && continueButton) {
      const nameLength = userNameInput.value.trim().length;
      if (nameLength >= 2 && captchaToken.register) {
        continueButton.classList.add("active");
      } else {
        continueButton.classList.remove("active");
      }
    }
  }
  window.updateContinueButtonState = updateContinueButtonState;

  // Continue with Name Button Handler (for new user registration)
  const continueWithNameButton = document.getElementById("continueWithNameButton");
  if (continueWithNameButton) {
    continueWithNameButton.addEventListener("click", async function (e) {
      e.preventDefault();

      // Hide any existing error message when user clicks Continue
      hideNameInputError();

      const userNameInput = document.getElementById("userNameInput");
      const userName = userNameInput ? userNameInput.value.trim() : "";

      if (userName.length < 2) {
        showNameInputError("Please enter a valid name (at least 2 characters)");
        return;
      }

      // Check if name contains numbers
      if (/\d/.test(userName)) {
        showNameInputError("Name should only contain letters and spaces");
        return;
      }

      const captcha = captchaToken.register;
      if (!captcha) {
        showNameInputError("Please complete the captcha verification");
        return;
      }

      // Disable button and show loading state
      continueWithNameButton.disabled = true;
      const originalText = continueWithNameButton.textContent;
      continueWithNameButton.textContent = "Signing up...";

      try {
        // API call to create user and send OTP (register)
        const nameParts = userName.trim().split(" ");
        const firstName = nameParts.shift(); // first word
        const lastName = nameParts.join(" "); // remaining words

        const response = await fetch(otpApiUrl("/users", captcha.useFallback), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            phone: userPhoneNumber,
            countryCode: userCountryCode,
            firstName: firstName,
            lastName: lastName,
            captchaSiteKey: captcha.captchaSiteKey,
            captchaToken: captcha.captchaToken,
            isCaptchaEnabled: true,
          }),
        });

        const data = await response.json();
        console.log("Create user and send OTP response:", data);

        if (response.ok && data.status === "success") {
          console.log("User created and OTP sent successfully");
          fireTrackGetOTPClick({
            status: "success",
            entered_mobile_number: userPhoneNumber,
            login_type: "sign_up",
          });
          // Hide error message on success
          hideNameInputError();
          hideCaptcha("register");
          // Show OTP verification screen
          showOTPView(userPhoneNumber, userCountryCode);
        } else {
          // Handle error from API
          const errorMessage = getErrorMessage(data?.errors, "Failed to create account. Please try again.");
          fireTrackGetOTPClick({
            status: "failed",
            entered_mobile_number: userPhoneNumber,
            login_type: "sign_up",
          });
          showNameInputError(errorMessage);
          console.error("User creation failed:", data);
          // Captcha tokens are one-time — refresh after failed attempt
          showCaptcha("register", updateContinueButtonState);
          updateContinueButtonState();
        }
      } catch (error) {
        // Handle network or other errors
        console.error("Error creating user:", error);
        fireTrackGetOTPClick({
          status: "failed",
          entered_mobile_number: userPhoneNumber,
          login_type: "sign_up",
        });
        showNameInputError("An error occurred. Please check your connection and try again.");
        showCaptcha("register", updateContinueButtonState);
        updateContinueButtonState();
      } finally {
        // Re-enable button and restore text
        continueWithNameButton.disabled = false;
        continueWithNameButton.textContent = originalText;
      }
    });
  }

  // Function to update Verify OTP button state
  function updateVerifyOTPButtonState() {
    const verifyButton = document.getElementById("verifyOTPButton");
    if (!verifyButton) return;

    let otpComplete = true;
    for (let i = 1; i <= 6; i++) {
      const input = document.getElementById("otp-" + i);
      if (!input || !input.value) {
        otpComplete = false;
        break;
      }
    }

    if (otpComplete) {
      verifyButton.classList.add("active");
    } else {
      verifyButton.classList.remove("active");
    }
  }

  // OTP Input auto-focus and validation
  const otpInputs = document.querySelectorAll(".otp-input");
  otpInputs.forEach((input, index) => {
    // Only allow numbers 0-9
    input.addEventListener("input", function (e) {
      const value = this.value;

      // Only allow single digit 0-9
      if (!/^[0-9]$/.test(value)) {
        this.value = "";
        return;
      }

      // Hide error when user starts typing
      hideOTPError();
      hideOTPVerifyError();

      // Update verify button state
      updateVerifyOTPButtonState();

      // Auto-focus next input
      if (value && index < otpInputs.length - 1) {
        otpInputs[index + 1].focus();
      }

      // Auto-submit when all 6 OTP digits are entered
      let otpComplete = true;
      for (let i = 1; i <= 6; i++) {
        const otpInput = document.getElementById("otp-" + i);
        if (!otpInput || !otpInput.value) {
          otpComplete = false;
          break;
        }
      }

      if (otpComplete) {
        // Small delay to ensure all inputs are filled
        setTimeout(() => {
          // Double-check all inputs are still filled before auto-submitting
          let stillComplete = true;
          for (let i = 1; i <= 6; i++) {
            const otpInput = document.getElementById("otp-" + i);
            if (!otpInput || !otpInput.value) {
              stillComplete = false;
              break;
            }
          }

          if (stillComplete) {
            const verifyOTPButton = document.getElementById("verifyOTPButton");
            if (verifyOTPButton && !verifyOTPButton.disabled) {
              handleVerifyOTP();
            }
          }
        }, 300);
      }
    });

    // Handle backspace and Enter key
    input.addEventListener("keydown", async function (e) {
      if (e.key === "Backspace" && !this.value && index > 0) {
        otpInputs[index - 1].focus();
        // Update verify button state after backspace
        setTimeout(updateVerifyOTPButtonState, 10);
      } else if (e.key === "Enter") {
        e.preventDefault();
        // Trigger verify OTP when Enter is pressed
        await handleVerifyOTP();
      }
    });

    // Handle paste
    input.addEventListener("paste", function (e) {
      e.preventDefault();
      const pastedData = e.clipboardData.getData("text").trim();
      const digits = pastedData.match(/\d/g);

      if (digits) {
        digits.slice(0, 6).forEach((digit, i) => {
          if (otpInputs[i]) {
            otpInputs[i].value = digit;
          }
        });

        // Focus last filled input or last input
        const lastIndex = Math.min(digits.length, otpInputs.length) - 1;
        if (otpInputs[lastIndex]) {
          otpInputs[lastIndex].focus();
        }

        // Update verify button state after paste
        updateVerifyOTPButtonState();

        // Auto-submit if all 6 digits were pasted
        if (digits.length >= 6) {
          setTimeout(() => {
            const verifyOTPButton = document.getElementById("verifyOTPButton");
            if (verifyOTPButton && !verifyOTPButton.disabled) {
              handleVerifyOTP();
            }
          }, 300);
        }
      }
    });
  });

  // Function to handle Verify OTP (reusable for both button click and Enter key)
  async function handleVerifyOTP() {
    const verifyOTPButton = document.getElementById("verifyOTPButton");

    // Hide any existing error message when user clicks Verify
    hideOTPVerifyError();

    // Collect OTP from inputs
    let otp = "";
    for (let i = 1; i <= 6; i++) {
      const input = document.getElementById("otp-" + i);
      if (input) {
        otp += input.value;
      }
    }

    // Validate OTP – must be exactly 6 digits (0-9 only), otherwise don't call backend
    if (!/^[0-9]{6}$/.test(otp)) {
      showOTPVerifyError("OTP must be a 6-digit code using only numbers (0-9).");
      showOTPError();
      return;
    }

    if (otp.length === 6) {
      const phone = document.getElementById("smlPhoneNumberInput").value;
      const countryCode = selectedCountry.code;

      // Disable button and show loading state
      if (verifyOTPButton) {
        verifyOTPButton.disabled = true;
        const originalText = verifyOTPButton.textContent;
        verifyOTPButton.textContent = "Verifying...";

        try {
          const pendingBuyNow = (() => {
            try {
              return JSON.parse(sessionStorage.getItem('pwPendingBuyNow') || 'null');
            } catch (e) {
              return null;
            }
          })();
          const redirectUrl = pendingBuyNow?.returnUrl
            || (window.location.pathname + window.location.search)
            || window.location.pathname;
          const params = new URLSearchParams(window.location.search);
          const toBoolean = (value) => {
            if (value === null || value === undefined) return false;
            if (typeof value === 'boolean') return value;
            return String(value).toLowerCase() === 'true';
          };
          const rawFromApp =
            params.get('from_app') ??
            params.get('fromApp') ??
            params.get('from_App') ??
            (typeof safeSessionStorageGet === 'function' ? safeSessionStorageGet('fromApp') : null);

          const fromApp = toBoolean(rawFromApp);
          const response = await fetch(`${window.PW_API_BASE || "/apps/pw_module/api"}/users/verify-otp`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              otp: otp,
              phone: phone,
              countryCode: countryCode,
              redirectUrl,
              fromApp
            }),
          });
          const data = await response.json();
          if (response.ok && data.status === "success") {
            console.log("OTP verified successfully!", data.data, data?.data?.redirect_url);
            // Hide error message on success
            hideOTPVerifyError();
            // Redirect to the URL provided in the response
            const tokenContext = {
              token: data?.data?.access_token,
              randomId: data?.data?.randomId,
            };
            const preferences = data?.data?.preferences;
            const exams = preferences?.exams;
            const cohort = exams?.[exams?.length - 1];
            const selectedExamName = cohort ? String(cohort).split("-").join(" ").trim() : "";
            const examIcon = preferences?.examIcon || "";
            const redirectUrl = preferences?.redirection_url || data?.data?.redirect_url || "/";
            const { pw_uuid: pwUserId, cohortId, phone, email , firstName, lastName , name} = data?.data;
            sessionStorage.setItem("user_data", JSON.stringify({ pwUserId, cohortId, phone, email, firstName, lastName, name }));
            localStorage.setItem("STORE_TOKEN_CONTEXT", JSON.stringify(tokenContext));
            localStorage.setItem("preferences", JSON.stringify(preferences || {}));
            // Check if user has changed cohort in this session - if so, preserve their selection
            const cohortChangedInSession = sessionStorage.getItem('cohortChangedInSession') === 'true';
            // Only update selectedExam* keys if user hasn't changed cohort in this session
            if (!cohortChangedInSession && (cohort || selectedExamName || examIcon)) {
              localStorage.setItem("selectedExamName", selectedExamName);
              localStorage.setItem("selectedExamIcon", examIcon);
              localStorage.setItem("selectedExamRedirectUrl", redirectUrl);
            }
            if (typeof window.markCartMigratePending === "function") {
              window.markCartMigratePending();
            } else {
              try {
                sessionStorage.setItem("pw-cart-migrate-pending", "1");
              } catch (e) {}
            }
            const loginPopup = document.getElementById("login-popup");
            if (data?.data?.redirect_url) {
              if (loginPopup) {
                const dialogComponent = loginPopup.querySelector("dialog");
                if (dialogComponent && dialogComponent.close) {
                  dialogComponent.close();
                }
              }
              // Mark OTP verification success for analytics validation on next page load
              // (so login-auth events fire only after OTP verify)
              try {
                sessionStorage.setItem('pwstOtpVerified', 'true');
                sessionStorage.setItem('pwstOtpVerifiedAt', String(Date.now()));
              } catch (e) {}
              sessionStorage.setItem('isUserLoggedIn', 'true');
              window.location.href = data?.data?.redirect_url;
              return;
            } else {
              // If no redirect URL, just close the popup
              if (loginPopup) {
                const dialogComponent = loginPopup.querySelector("dialog");
                if (dialogComponent && dialogComponent.close) {
                  dialogComponent.close();
                }
              }
              pwstMaybeOpenCartAfterLogin();
            }
          } else {
            // Handle error from API
            const errorMessage = getErrorMessage(data?.errors, "Invalid OTP. Please try again.");
            console.log("OTP verification error:", errorMessage);
            showOTPVerifyError(errorMessage);
            showOTPError();
            sessionStorage.setItem('loginError', 'true');
            sessionStorage.setItem('loginErrorMessage', errorMessage);
            if (typeof trackLoginAuthToDataLayer === 'function') {
              trackLoginAuthToDataLayer({ status: 'error', error_message: errorMessage });
            }
          }
        } catch (error) {
          console.error("Error verifying OTP:", error);
          const genericErrorMessage = "An error occurred while verifying OTP. Please check your connection and try again.";
          showOTPVerifyError(genericErrorMessage);
          sessionStorage.setItem('loginError', 'true');
          sessionStorage.setItem('loginErrorMessage', genericErrorMessage);
          if (typeof trackLoginAuthToDataLayer === 'function') {
            trackLoginAuthToDataLayer({ status: 'error', error_message: genericErrorMessage });
          }
        } finally {
          // Re-enable button and restore text
          if (verifyOTPButton) {
            verifyOTPButton.disabled = false;
            verifyOTPButton.textContent = originalText;
          }
        }
      }
    } else {
      showOTPVerifyError("Please enter the complete 6-digit OTP");
    }
  }

  // Verify OTP Button Handler
  const verifyOTPButton = document.getElementById("verifyOTPButton");
  if (verifyOTPButton) {
    verifyOTPButton.addEventListener("click", async function (e) {
      e.preventDefault();
      await handleVerifyOTP();
    });
  }

  // Country Code Selector Functionality
  const countryCodeButton = document.getElementById("countryCodeButton");
  const countrySelector = document.getElementById("countrySelector");
  const countrySearchInput = document.getElementById("countrySearchInput");
  const countryList = document.getElementById("countryList");

  // Open country selector
  if (countryCodeButton) {
    countryCodeButton.addEventListener("click", function (e) {
      e.stopPropagation();
      openCountrySelector();
    });
  }

  // Prevent country selector from closing the main dialog
  if (countrySelector) {
    countrySelector.addEventListener("click", function (e) {
      e.stopPropagation(); // Prevent dialog close
      if (e.target === countrySelector) {
        closeCountrySelector();
      }
    });
  }

  // Search functionality
  if (countrySearchInput) {
    countrySearchInput.addEventListener("input", function () {
      const searchTerm = this.value.toLowerCase().trim();
      filterCountries(searchTerm);
    });
  }

  // Fetch countries from API
  async function fetchCountries() {
    try {
      // Using restcountries API
      const response = await fetch("https://static.pw.live/auth-fe/assets/json/app-constants.json");
      const data = await response.json();
      countriesData = data.map((country) => {
        return {
          name: country.n,
          code: country?.d,
          iso: country.c,
        };
      });

      displayCountries(countriesData);
    } catch (error) {
      console.error("Error fetching countries:", error);
      countryList.innerHTML = '<div class="country-selector-empty">Failed to load countries. Please try again.</div>';
    }
  }

  // Display countries in list
  function displayCountries(countries) {
    if (countries.length === 0) {
      countryList.innerHTML = '<div class="country-selector-empty">No countries found</div>';
      return;
    }

    countryList.innerHTML = countries
      .map(
        (country) => `
      <button type="button" class="country-item" data-code="${country.code}" data-iso="${country.iso}" data-name="${country.name}">
        <div class="country-item-left">
          <span class="country-item-code">${country.iso} ${country.code}</span>
          <span class="country-item-name">(${country.name})</span>
        </div>
      </button>
    `
      )
      .join("");

    // Add click handlers to country items
    const countryItems = countryList.querySelectorAll(".country-item");
    countryItems.forEach((item) => {
      item.addEventListener("click", function () {
        const code = this.getAttribute("data-code");
        const iso = this.getAttribute("data-iso");
        const name = this.getAttribute("data-name");
        selectCountry({ code, iso, name });
      });
    });
  }

  // Filter countries based on search
  function filterCountries(searchTerm) {
    if (!searchTerm) {
      displayCountries(countriesData);
      return;
    }

    const filtered = countriesData.filter((country) => country.name.toLowerCase().includes(searchTerm) || country.code.toLowerCase().includes(searchTerm) || country.iso.toLowerCase().includes(searchTerm));

    displayCountries(filtered);
  }

  // Select a country
  function selectCountry(country) {
    selectedCountry = country;
    const selectedCountryCode = document.getElementById("selectedCountryCode");
    if (selectedCountryCode) {
      selectedCountryCode.textContent = `${country.iso} ${country.code}`;
    }
    closeCountrySelector();
  }

  // Open country selector
  window.openCountrySelector = function () {
    if (countrySelector) {
      countrySelector.style.display = "flex";

      // Load countries if not loaded
      if (countriesData.length === 0) {
        fetchCountries();
      }

      // Focus search input
      setTimeout(() => {
        if (countrySearchInput) {
          countrySearchInput.focus();
        }
      }, 100);

      // Prevent clicks on the popup from closing the dialog
      const popup = countrySelector.querySelector(".country-selector-popup");
      if (popup) {
        popup.addEventListener("click", function (e) {
          e.stopPropagation();
        });
      }
    }
  };

  // Close country selector
  window.closeCountrySelector = function () {
    if (countrySelector) {
      countrySelector.style.display = "none";
      if (countrySearchInput) {
        countrySearchInput.value = "";
      }
      displayCountries(countriesData);
    }
  };

  // Reset popup to initial state
  function resetLoginPopup() {
    const loginFormContent = document.getElementById("login-form-content");
    const otpVerificationContent = document.getElementById("otp-verification-content");
    const nameInputContent = document.getElementById("name-input-content");
    const contentView = document.getElementById("content-view");
    const closeButton = document.getElementById("popup-close-button");

    // Reset previous view tracker
    previousView = "login";

    // Show login form, hide all other views
    if (loginFormContent) loginFormContent.style.display = "block";
    if (otpVerificationContent) otpVerificationContent.style.display = "none";
    if (nameInputContent) nameInputContent.style.display = "none";
    if (contentView) contentView.style.display = "none";
    if (closeButton) closeButton.style.display = "flex";

    // Clear phone input
    const phoneInput = document.getElementById("smlPhoneNumberInput");
    if (phoneInput) {
      phoneInput.value = "";
      // Auto-focus phone input to open numeric keypad on mobile
      setTimeout(() => {
        if (phoneInput && loginFormContent && loginFormContent.style.display !== "none") {
          phoneInput.focus();
        }
      }, 300);
    }

    // Clear name input
    const nameInput = document.getElementById("userNameInput");
    if (nameInput) nameInput.value = "";

    // Clear OTP inputs
    clearOTPInputs();

    // Clear any error messages
    hideOTPError();
    hideGetOTPError();
    hideOTPVerifyError();
    hideNameInputError();

    // Clear any timers
    if (resendTimer) {
      clearInterval(resendTimer);
      resendTimer = null;
    }

    // Reset button states and remove active class
    const getOTPButton = document.getElementById("getOTPButton");
    if (getOTPButton) {
      getOTPButton.disabled = false;
      getOTPButton.textContent = "Get OTP";
      getOTPButton.classList.remove("active");
    }

    const verifyOTPButton = document.getElementById("verifyOTPButton");
    if (verifyOTPButton) {
      verifyOTPButton.disabled = false;
      verifyOTPButton.textContent = "Verify & Proceed";
      verifyOTPButton.classList.remove("active");
    }

    const continueButton = document.getElementById("continueWithNameButton");
    if (continueButton) {
      continueButton.disabled = false;
      continueButton.textContent = "Continue";
      continueButton.classList.remove("active");
    }

    // Show captcha as soon as login modal opens (before phone is entered)
    hideCaptcha("resend");
    setTimeout(function () {
      showCaptcha("send", window.updateGetOTPButtonState);
    }, 100);
  }

  // Listen for dialog open event and reset the popup
  const loginPopup = document.getElementById("login-popup");
  if (loginPopup) {
    loginPopup.addEventListener("dialog:open", function () {
      if (typeof trackLoginPageVisit === "function") {
        requestIdleCallback(function () {
          trackLoginPageVisit();
        });
      }

      // Show the component when dialog opens
      loginPopup.classList.add("is-open");
      loginPopup.style.display = "block";
      loginPopup.style.visibility = "visible";
      loginPopup.style.opacity = "1";

      const dialog = loginPopup.querySelector(".login-popup__dialog");
      if (dialog) {
        dialog.style.display = "flex";
        dialog.style.visibility = "visible";
        dialog.style.opacity = "1";
        dialog.style.pointerEvents = "auto";
        dialog.style.position = "fixed";
        dialog.style.top = "50%";
        dialog.style.left = "50%";
        dialog.style.transform = "translate(-50%, -50%)";
      }

      resetLoginPopup();
    });

    // Listen for dialog close event
    loginPopup.addEventListener("dialog:close", function () {
      // Hide the component when dialog closes
      loginPopup.classList.remove("is-open");
      loginPopup.style.display = "none";
      loginPopup.style.visibility = "hidden";
      loginPopup.style.opacity = "0";
      hideCaptcha("send");
      hideCaptcha("resend");
      hideCaptcha("register");
      window.__PW_LOGIN_FIRST_DIGIT_TRACKED__ = false;
      sessionStorage.removeItem('isNewUser');
      sessionStorage.removeItem('pwstOtpVerified');
      sessionStorage.removeItem('pwstOtpVerifiedAt');
      sessionStorage.removeItem('loginError');
      sessionStorage.removeItem('loginErrorMessage');
      sessionStorage.removeItem('pwstOpenCartAfterLogin');
    });
  }
});
